<!--添加线索跟进记录-->
<template>
  <article>
    <group title="提醒设置">
      <datetime title="预约到店" class="datetime" placeholder="请选择预约到店时间" v-model="content.next_arrive_at"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成" cancel-text="取消" :min-hour="8"
                :max-hour="19" :start-date="start_date" :end-date="end_date"></datetime>
      <datetime title="下次致电" class="datetime" placeholder="请选择下次致电时间" :start-date="start_date" :end-date="end_date"
                format="YYYY-MM-DD" year-row="{value}年" month-row="{value}月" day-row="{value}日" confirm-text="完成"
                cancel-text="取消" v-model="content.next_contact_at"></datetime>
    </group>
    <group title="其他备注">
      <x-textarea placeholder="请记录你的跟进情况，不少于3个且不超过60个文字" v-model="content.remark" :show-counter="false" :max="60"
                  class="sale-record-text"
                  ref=autosize></x-textarea>
    </group>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="toSave()">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  XTextarea,
  Datetime,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'

export default {
  components: {
    XTextarea,
    Datetime,
    Group
  },
  data () {
    return {
      start_date: null,
      end_date: null,
      content: {
        clue_id: '',
        next_arrive_at: '',
        next_contact_at: '',
        remark: ''
      }
    }
  },
  created () {
    this.start_date = this.futureTime(1)
    this.end_date = this.futureTime(180)
    this.content.clue_id = parseInt(this.$route.params.id)
  },
  methods: {
    futureTime (days) {
      let millSeconds = Math.abs(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
      let future = new Date(millSeconds)
      let year = future.getFullYear()
      let month = future.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = future.getDate()
      if (date < 10) date = '0' + date
      return (year + '-' + month + '-' + date)
    },
    toSave () {
      if (!this.content.clue_id) return
      let remark = this.content.remark
      if (!remark) {
        this.showToast('请输入备注信息')
        return false
      } else if (remark.length < 3 || remark.length > 60) {
        this.showToast('备注应为3~60个文字之间')
        return false
      }
      this.$rest.saleManage.addClueRecord({
        clue_id: this.content.clue_id,
        next_arrive_at: this.content.next_arrive_at ? this.content.next_arrive_at + ':00' : null,
        next_contact_at: this.content.next_contact_at ? this.content.next_contact_at : null,
        remark: this.content.remark
      }).then(res => {
        if (res.code === 0) {
          window.document.activeElement.blur()
          // 删除线索档案详情缓存
          cache.clearSessionData('clueArchivesLocalData')
          this.showToast('提交成功')
          this.$router.go(-1)
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
